module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.routes), function(route) {
    return _c('div', {
      key: route.name
    }, [_c('router-link', {
      attrs: {
        "to": route.path
      }
    }, [_vm._v(_vm._s(route.name))])], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c0f3f26","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/components/Home.vue
// module id = 60
// module chunks = 0